import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MobileResponsiveService } from 'src/app/services/mobile-view/mobile-responsive.service';
import { ToastrService } from 'ngx-toastr';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { LoaderService } from 'src/app/service/loader/loader.service';
import { SharedService } from 'src/app/service/shared/shared.service';
import { Config } from 'src/app/app-constant';
import { ToastController } from '@ionic/angular';
import { PdfDownloadService } from 'src/app/pdf-download-service.service';
import { DataRefreshService } from 'src/app/services/dataRefreshService.service';
import { calculateFiscalYear, formatYearRanges } from 'src/app/shared/commen-function-file';
import { SkipDayPopupComponent } from '../skip-day-popup/skip-day-popup.component';
import { DwmaudittrailComponent } from '../../DWM-Audit-Trail/dwmaudittrail/dwmaudittrail.component';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { GetCompanyAndUsersData } from 'src/app/services/get-company-and-users-data/get-company-and-users-data.service';
import { formatText } from 'src/app/shared/commen-function-file';
import { DwmattachmentpopupComponent } from '../dwmattachmentpopup/dwmattachmentpopup.component';
import { DwmGenericServiceService, TableState } from '../../_DWM-Generic-Services/generic-service.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-my-dwm-update',
  templateUrl: './my-dwm-update.component.html',
  styleUrls: ['./my-dwm-update.component.scss']
})
export class MyDwmUpdateComponent implements OnInit {
  loggedInUserCompanyID: any;
  loggedInCompanyFiscalyear: any;
  loggedInUserEmpCode: any | null;
  loggedInUserId: any | null;
  loggedInCompanyMDCode: any | null;
  loggedInUserRole: any;
  loggedInUserRoles: any;
  subModuleButtonColor: any | null;
  buttonColorName: any;
  loggedInCompanyReviewCycle: any | null;
  loggedInUserRoleIsEmployee: any;
  fromYear: any;
  selectedYear: any;
  toYear: any;
  selectedMonth = '';
  months: string[] = [];
  pmsYears: any = [];
  showCopyButton = false;
  isCurrentYearSelected: boolean = false;
  getMonthsByFiscalandReviewCycle: any = [];
  selectedYearForDWM: any = null;
  selectedMonthForDWM: string = '';
  dwmPlusFormDate: Date = new Date();
  editRowIndex: number | null = null;
  backupRowData: any = null;
  searchTaskString: any = null;
  currentPageNumber: any = 1;
  selectedSizeOfTask: any = 25;
  toggleDownloadBtn: boolean = false;
  taskList: any[] = [];
  showingCount: any = 1;
  showingOfCount: any = 0;
  totalTaskCount: any;
  totalTaskPages: any = 0;
  productList: any[] = [];
  loggedInUserName: any;
  selectedTaskList: any = [];
  selectAllTaskCheckbox: boolean = false;
  showTableCardBox = false;
  isRNDEmployee = false;
  isL4AndAboveEmployee = false;
  isManagerOrHod = false;
  isEmployeeOnly = false;
  isEmployeeAndHod = false;
  isEmployeeAndManager = false;

  today: Date = new Date();
  categoryMap: { [key: number]: string } = {};
  isSkipDaySubmitted = false;
  formatedataVariable = formatText;

  isExitedSelectedDate: any = null;

  constructor(
    public sharedService: SharedService,
    public dialogRef: MatDialogRef<MyDwmUpdateComponent>,
    private loader: LoaderService,
    public mobileResponsiveService: MobileResponsiveService,
    private encryptionService: EncryptionService,
    private httpService: HttpService,
    private config: Config,
    public router: Router,
    private fb: FormBuilder,
    public dialog: MatDialog,
    private activatedroute: ActivatedRoute,
    private datePipe: DatePipe,
    private toastr: ToastrService,
    private toastController: ToastController,
    private cdRef: ChangeDetectorRef,
    private PdfDownload: PdfDownloadService,
    private dataRefreshService: DataRefreshService,
    public dwmGenericServiceService: DwmGenericServiceService,
    private getCompanyAndUserData: GetCompanyAndUsersData
  ) {}

  dwmData: any[] = [];

  // --------------- DWM Table Header Names -----------------

  dwmTableHeaderNames: string[] = ['Category', 'Actionable', 'Product No', 'Plant', 'Duration', 'Date', 'Time From', 'Time To', 'Frequency', 'Status', 'Employee Comment', 'Manager Comment', 'Attachment', 'Audit Trail', 'Action'];

  categoryList = ['Productivity', 'Quality', 'Cost', 'Delivery', 'Safety', 'Morale', 'Environment', 'Finance', 'Customer', 'Process', 'People', 'Project'];

  // statusList = ['Not_Started', 'In_Progress', 'Completed'];
  statusList = [
    { value: 'Not_Started', label: 'Not Completed' },
    { value: 'In_Progress', label: 'In Progress' },
    { value: 'Completed', label: 'Completed' }
  ];

  frequencyList: string[] = ['Daily', 'Weekly', 'Fortnight', 'Monthly', 'Quarterly', 'Semi-Annually', 'Annually'];

  ngOnInit() {
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.subModuleButtonColor = sessionStorage.getItem('subModuleButtonColor');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));

    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    this.loggedInUserEmpCode = sessionStorage.getItem('empCode');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.loggedInUserName = sessionStorage.getItem('loggedInUserName');
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    this.loggedInCompanyMDCode = sessionStorage.getItem('loggedInCompanyMDCode');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.loggedInUserRoles = JSON.parse(sessionStorage.getItem('loggedInUserRoles') || '[]');
    console.log('user roles are..', this.loggedInUserRoles);
    this.loggedInCompanyReviewCycle = sessionStorage.getItem('loggedInCompanyReviewCycle') || null;
    if (this.loggedInUserRoles.length == 1) {
      for (let i = 0; i < this.loggedInUserRoles?.length; i++) {
        if (this.loggedInUserRoles[i].displayName == 'Employee') {
          this.loggedInUserRoleIsEmployee = true;
        }
      }
    }

    this.getpmsyearlist();
    this.setUserRoleAccess();
    this.getDwmUpdateData();
  }

  getpmsyearlist() {
    this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.pmsYears = formatYearRanges(data?.data?.yearRanges);

      const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);

      const yearValue = `${fiscalStartYear}-${fiscalEndYear}`;

      this.setSelectedYear(yearValue);
    });
  }

  setSelectedYear(yearValue: string): void {
    const selectedYearObj = this.pmsYears.find((ele: any) => ele.year === yearValue);
    if (selectedYearObj) {
      this.selectedYearForDWM = selectedYearObj?.year;

      let test = selectedYearObj?.year.split('-');
      this.fromYear = test[0];
      this.toYear = test[1];
      this.defaultCallFunctionsList();
      [this.fromYear, this.toYear] = selectedYearObj.year.split('-');
    }
  }

  defaultCallFunctionsList() {
    this.getDWMCatwegoryList();
    this.getEmployeeList();
    this.getSkippedDayData();
    this.getProductsData();
    this.getDWMSetup();
    // this.getComplianceAndAchievment()
  }

  selectYearSetup(year: any) {
    this.selectedYearForDWM = year;
    this.selectedYear = year;
    this.defaultCallFunctionsList();
  }

  getYearSetupForDWM(year: any) {
    this.selectedYearForDWM = year;
    this.selectedYear = year;
    const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);
    const currentFiscalYear = `${fiscalStartYear}-${fiscalEndYear}`;
    this.isCurrentYearSelected = year === currentFiscalYear;
  }

  selectedDwmDate: Date | null = null;
  selectedDate: Date = new Date();

  onDateChange() {
    if (this.dwmPlusFormDate) {
      this.getSkippedDayData();
    }
    this.getDwmUpdateData();
  }

  //  --------------------------- Logged IN User Roles -------------------------------

  setUserRoleAccess() {
    const role = this.loggedInUserRole;
    this.isManagerOrHod = role === 'Manager' || role === 'HOD';
    this.isEmployeeOnly = role === 'Employee';
    this.isEmployeeAndManager = role === 'Employee' || role === 'HOD';
    this.isEmployeeAndHod = role === 'Employee' || role === 'Manager';
  }

  // ----------------------------- Filter Employees R&D and L4_Above ----------------------
  getEmployeeList() {
    this.getCompanyAndUserData.getAllEmployeeByCompanyID().subscribe((res: any) => {
      const empList = res?.data || [];
      const loggedInEmpId = this.loggedInUserId;
      const loggedInEmployee = empList.find((emp: any) => emp.id === loggedInEmpId);
      /* ---------------- R&D Role ---------------- */
      this.isRNDEmployee = loggedInEmployee?.department === 'R&D';
      // console.log('RND EMployeee...............', this.isRNDEmployee);
      /* ---------------- L4 & Above Role ---------------- */
      this.isL4AndAboveEmployee = this.checkL4AndAbove(loggedInEmployee?.grade);
    });
  }

  // ----------------------- Check L4 and Above Employees ---------------------
  checkL4AndAbove(grade: string | null): boolean {
    if (!grade) return false;
    const level = Number(grade.replace('L', ''));
    return level >= 4;
  }

  editRow(index: number) {
    this.dwmUpdateData.forEach((task: any, i: number) => {
      if (i !== index) task.isEdit = false;
    });
    if (!this.dwmUpdateData[index].backup) {
      this.dwmUpdateData[index].backup = { ...this.dwmUpdateData[index] };
    }

    this.dwmUpdateData[index].isEdit = true;
  }

  cancelEdit(item: any, index: number) {
    if (item.backup) {
      this.dwmUpdateData[index] = { ...item.backup, isEdit: false };
      delete this.dwmUpdateData[index].backup;
    } else {
      this.dwmUpdateData[index].isEdit = false;
    }
  }

  maxDurationError = false;

  onDurationInput(item: any, event?: Event) {
    // ---------------- BLOCK INVALID KEYS ----------------
    if (event && event.type === 'keydown') {
      const keyboardEvent = event as KeyboardEvent;

      const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];

      if (allowedKeys.includes(keyboardEvent.key)) {
        return;
      }

      // Block everything except numbers
      if (!/^\d$/.test(keyboardEvent.key)) {
        keyboardEvent.preventDefault();
        return;
      }
    }

    let value = item.dwmDuration || '';
    this.maxDurationError = false;
    //  Remove everything except digits
    value = value.replace(/\D/g, '');

    //  Insert colon after hours
    if (value.length > 2) {
      value = value.slice(0, value.length - 2) + ':' + value.slice(-2);
    }

    let [hours, minutes] = value.split(':');

    // Limit hours length
    if (hours && hours.length > 2) {
      hours = hours.slice(0, 2);
    }

    // Convert to numbers for validation
    const h = Number(hours);
    const m = minutes ? Number(minutes) : 0;

    // ---------- VALIDATION : MAX 24:00 ----------
    if (h > 24 || (h === 24 && m > 0)) {
      this.maxDurationError = true;

      // Stop further input
      if (event && event.type === 'keydown') {
        (event as KeyboardEvent).preventDefault();
      }
      return;
    }

    // Minutes validation
    if (minutes) {
      minutes = minutes.slice(0, 2);
      if (+minutes > 59) minutes = '59';
    }

    item.dwmDuration = minutes !== undefined ? `${hours}:${minutes}` : hours;
  }

  onDurationBlur(item: any) {
    if (!item.dwmDuration) return;

    let [hours, minutes] = item.dwmDuration.split(':');

    // Auto pad minutes
    if (minutes && minutes.length === 1) {
      minutes = '0' + minutes;
    }

    // Auto pad hours
    if (hours && hours.length === 1) {
      hours = '0' + hours;
    }

    item.dwmDuration = minutes ? `${hours}:${minutes}` : hours;
  }

  // ======================= Skip Day popup ============================

  skipDayModalPopup(rejectedData?: any, resubmit: boolean = false) {
    console.log('44444444.........', this.dwmUpdateData);

    const dialogRef = this.dialog.open(SkipDayPopupComponent, {
      // width: '390px',
      maxWidth: '400px',
      panelClass: ['phi_mdc_dialog__container_100_phi_mdc_dialog__content_85_vh'],
      data: { selectedDay: this.dwmPlusFormDate, data: rejectedData ? rejectedData : this.dwmUpdateData, resubmit }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === true) {
        this.isSkipDaySubmitted = true;
        this.getDwmUpdateData();
        // console.log('Skip Day submitted:', result);
      }
    });
  }

  checkLengthOfField(string: any) {
    if (string.length > 254) {
      this.toastr.warning('The text cannot exceed 255 characters.', '', {
        timeOut: 3000
      });
    }
  }

  //  resubmit skip day
  onRejectedSkipDayClick(): void {
    // allow resubmission only if rejected
    if (!this.isSkipDayRejected) return;
    console.log(this.isSkipDayRejectedData);
    this.skipDayModalPopup(this.isSkipDayRejectedData, true);
  }

  //  =================== Get for the skip day ====================================

  // --------------------------------- Get Skipped data -----------------------

  skippedDayData: any[] = [];
  hasSkipDayRecord = false;
  isSkipDayApproved = false;
  isSkipDayRejected = false;
  isSkipDayRejectedData: any = [];

  getSkippedDayData() {
    // reset everything first
    this.hasSkipDayRecord = false;
    this.isSkipDayApproved = false;
    this.isSkipDayRejected = false;
    this.isSkipDaySubmitted = false;
    this.isSkipDayRejectedData = [];

    this.httpService.callGetService(`${this.config.getSkipDay}?companyId=${this.loggedInUserCompanyID}`).subscribe((res: any) => {
      const loggedUserId = Number(this.loggedInUserId);
      const allRecords = res.data || [];

      // only logged-in user records
      this.skippedDayData = allRecords.filter((d: any) => Number(d.userId) === loggedUserId);
      console.log('this.skippedDayData - - - - -  ', this.skippedDayData);
      const selectedDate = this.formatDate(this.dwmPlusFormDate || new Date());

      // 🔥 LATEST record for selected date
      const latestRecord = this.skippedDayData.filter(d => d.dwmDate === selectedDate).sort((a, b) => b.id - a.id)[0];

      if (!latestRecord) return;

      this.hasSkipDayRecord = true;

      if (latestRecord.isSkipped === true) {
        // Approved
        this.isSkipDayApproved = true;
      } else if (latestRecord.isSkipped === false) {
        // Rejected
        this.isSkipDayRejected = true;
        this.skippedDayData.map((skipData: any) => {
          const matchDate = this.formatDate(this.dwmPlusFormDate) == this.formatDate(skipData.dwmDate);
          if (matchDate && +skipData.userId == +this.loggedInUserId) {
            this.isSkipDayRejectedData = [...this.isSkipDayRejectedData, skipData];
          }
        });
      } else {
        // Submitted (null)
        this.isSkipDaySubmitted = true;
      }
    });
  }

  // ================================== Audit popup ======================================

  auditpopup(taskId: number) {
    const dialogRef = this.dialog.open(DwmaudittrailComponent, {
      panelClass: ['phi_mdc_dialog__container_100_phi_mdc_dialog__content_85_vh'],
      disableClose: true,
      data: {
        taskId: taskId // Pass the task ID to the audit component
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
      }
    });
  }

  // ================================ DWM Status =====================================================

  //     changeStatus(item: any, status: string): void {
  //   if ( item.dwmStatus === status) return;

  //   item.dwmStatus = status;
  //   this.saveUpdateDWM(item);
  // }

  changeStatus(item: any, status: string, isDelay: boolean = false): void {
    if (item.dwmStatus === status && !isDelay) return;

    item.dwmStatus = status;

    // mark doneWithDelay true if clicked as delay
    if (isDelay) {
      item.doneWithDelay = true;
    }

    if (item.categoryName !== 'R&D') {
      this.saveUpdateDWM(item);
    }
  }

  // ================================= Get DWM Category List ======================================
  rAndDCategoryId: number | null = null;
  getDWMCatwegoryList() {
    this.httpService.callGetService(`${this.config.getCategoriesList}?companyId=${this.loggedInUserCompanyID}`).subscribe((data: any) => {
      const categories = data?.data || [];
      categories.forEach((item: any) => {
        this.categoryMap[item.categoryId] = item.categoryName;
        if (item.categoryName === 'R&D') {
          this.rAndDCategoryId = item.categoryId;
        }
        console.log('R&D category..', this.rAndDCategoryId);
      });

      this.getDwmUpdateData();
    });
  }

  // ================================= Get the data for update DWM ======================================
  dwmUpdateData: any[] = [];

  // ----------------------------------- Update DWM --------------------------------------------------------

  // ----------------------------------------------- Get Product for Dropdown -------------------------------

  // getProductNo() {
  //   this.httpService
  //     .callGetService(
  //       `${this.config.getProductNumbers}?companyId=${this.loggedInUserCompanyID}&year=${this.selectedYearForDWM}&fiscalYear=${this.loggedInCompanyFiscalyear}`
  //     )
  //     .subscribe((data: any) => {
  //       console.log('get product data :', data);
  //       this.productList = data?.data || [];
  //     });
  // }

  //  ------------------------------------------- Get Plant Location ------------------------------------
  onProductChange(item: any): void {
    const selectedProduct = this.productList.find(p => p.productId === item.productId);

    if (!selectedProduct) {
      item.productNumber = null;
      item.plantLocation = '';
      return;
    }

    item.productNumber = selectedProduct.productNumber;
    item.plantLocation = selectedProduct.plantLocation;
  }

  // ------------------------------------------------ Get Update DWM Data ---------------------------------------------

  isRNDNewRow(item: any): boolean {
    return item.categoryName === 'R&D' && item.isNew === true;
  }

  isNonRND(item: any): boolean {
    return item.categoryName !== 'R&D';
  }

  // Rejected by manager
  //   get rejectedReason(): string {
  //   const rejectedTask = this.skippedDayData?.find(
  //     (t: any) => t.managerComment
  //   );
  //   console.log("Commented.............",rejectedTask)
  //   return rejectedTask?.managerComment ;
  // }
  get rejectedReason(): string {
    const selectedDate = this.formatDate(this.dwmPlusFormDate || new Date());

    const record = this.skippedDayData?.filter(d => d.dwmDate === selectedDate && d.isSkipped === false).sort((a, b) => b.id - a.id)[0];

    return record?.managerComment || '';
  }

  getDwmUpdateData(): void {
    // ------------------ API Call ------------------
    this.httpService.callGetService(`${this.config.getDwmUpdate}?companyId=${this.loggedInUserCompanyID}&userId=${this.loggedInUserId}&dwmEventDate=${this.formatDate(this.dwmPlusFormDate || new Date())}`).subscribe((response: any) => {
      // console.log('Testing.............', response);
      let allTasks = response?.data || [];

      this.isExitedSelectedDate = this.dwmGenericServiceService.checkIfIsExitedSelectedDate(this.dwmPlusFormDate);

      console.log('dddddddddddddddd.........', this.isExitedSelectedDate);
      allTasks = allTasks.filter((task: any) => {
        return (this.isRNDEmployee || task.categoryId !== this.rAndDCategoryId) && task.dwmStatus !== 'Rejected' && +task.userId === +this.loggedInUserId && this.getCompanyAndUserData.compareTwoDates(new Date(this.dwmPlusFormDate).toLocaleDateString('en-CA'), task.dwmEventDate);
      });

      allTasks = allTasks.map((task: any) => {
        // find product in productList by productId
        const selectedProduct = this.productList.find((p: any) => p.productId === task.productId);

        const attachments = task.dwmDoc ? task.dwmDoc.split(',') : [];

        return {
          ...task,
          doneWithDelay: task.doneWithDelay === true,
          dwmDuration: task.dwmDuration ? task.dwmDuration.substring(0, 5) : null,
          categoryName: this.categoryMap[task.categoryId] || '-',
          dwmStatus: this.statusList.some(s => s.value === task.dwmStatus) ? task.dwmStatus : 'Not_Started',
          empComment: task.empComments || '',
          attachments: attachments,
          hasSavedAttachments: attachments.length > 0,

          productId: selectedProduct?.productId ?? null, // bind to ngModel
          productNumber: selectedProduct?.productNumber ?? '', // optional, for reference
          plantLocation: selectedProduct?.plantLocation ?? task.plantLocation ?? ''
        };
      });

      // ------------------ Assign to UI List ------------------
      this.dwmUpdateData = allTasks;

      // ------------------ Reset Checkbox State ------------------
      this.dwmUpdateData.forEach((task: any) => (task.checkboxCheck = false));
      this.selectAllTaskCheckbox = false;
      this.selectedTaskList = [];

      // console.log('Filtered Task List:', this.dwmUpdateData);

      // ------------------ Pagination Logic ------------------
      this.totalTaskCount = this.dwmUpdateData.length;
      this.totalTaskPages = Math.ceil(this.totalTaskCount / this.selectedSizeOfTask);

      const startIndex = (this.currentPageNumber - 1) * this.selectedSizeOfTask;
      const endIndex = startIndex + this.selectedSizeOfTask;

      this.showingOfCount = Math.min(endIndex, this.totalTaskCount);
      this.dwmUpdateData = this.dwmUpdateData.slice(startIndex, endIndex);
    });
  }

  //  Employee Comment save

  onEmpCommentFocus(item: any): void {
    item._prevComment = item.empComments;
  }

  onEmpCommentBlur(item: any): void {
    if (item._prevComment === item.empComments) return;

    if (item.categoryName === 'R&D' && item.isNew) {
      return;
    }

    if (item.categoryName !== 'R&D') {
      this.saveUpdateDWM(item);
    }
  }

  saveUpdateDWM(item: any): void {
    const doneWithDelay = item.dwmStatus === 'Completed' && item.doneWithDelay === true;
    const payload = [
      {
        id: item.id ? item.id : null,
        dwmMasterId: item.dwmMasterId,
        companyId: this.loggedInUserCompanyID,
        managerId: item.managerId ?? null,
        dwmEventDate: item.dwmEventDate,
        dwmDuration: item.dwmDuration,
        empComments: item.empComments,
        managerComments: item.managerComment,
        dwmStatus: item.dwmStatus,
        doneWithDelay: doneWithDelay,
        dwmDoc: item.attachments?.join(',') || null,
        isCriticalTask: item.isCriticalTask
      }
    ];
    // (console.log('After item save..', item.attachments), console.log('FINAL PAYLOAD ', payload));

    this.httpService.callPostService(this.config.updateDWM, payload).subscribe({
      next: () => {
        this.toastr.success(item.id ? 'Updated successfully' : 'Saved successfully');
        this.getDwmUpdateData();
        item.isEdit = false;
      },
      error: () => {
        this.toastr.error('Save failed');
      }
    });
  }

  updatedEmpData: any[] = [];

  // ------------------------------------------------Search Task ---------------------------------------------

  onSearchTask(searchString: any) {
    this.searchTaskString = searchString;
    this.currentPageNumber = 1;

    if (!searchString || !searchString.trim()) {
      this.getDwmUpdateData();
      return;
    }

    const search = searchString.toLowerCase();

    this.dwmUpdateData = this.dwmUpdateData.filter((task: any) => task.actionable?.toLowerCase().includes(search) || task.dwmStatus?.toLowerCase().includes(search) || task.empComments?.toLowerCase().includes(search) || task.dwmFrequency?.toLowerCase().includes(search) || task.managerComments?.toLowerCase().includes(search));

    this.totalTaskCount = this.dwmUpdateData.length;
    this.totalTaskPages = Math.ceil(this.totalTaskCount / this.selectedSizeOfTask);

    this.showingCount = 1;
    this.showingOfCount = this.totalTaskCount;
  }

  // ------------------------------------------------ Sort Ascending ---------------------------------------------
onSortAssending(col: string) {
  this.sortTable(col, true);
}

onSortDesending(col: string) {
  this.sortTable(col, false);
}

sortTable(col: string, asc: boolean) {
  const map: any = {
    'Category': 'categoryName',
    'Actionable': 'actionable',
    'Product No': 'productNumber',
    'Plant': 'plantLocation',
    'Duration': 'dwmDuration',
    'Date': 'dwmEventDate',
    'Time From': 'timeFrom',
    'Time To': 'timeTo',
    'Frequency': 'dwmFrequency',
    'Status': 'dwmStatus',
    'Employee Comment': 'empComments',
    'Manager Comment': 'managerComments'
  };

  const key = map[col];

  this.dwmUpdateData.sort((a, b) => {
    const x = a[key] ?? '';
    const y = b[key] ?? '';

    return asc
      ? ('' + x).localeCompare(y, undefined, { numeric: true })
      : ('' + y).localeCompare(x, undefined, { numeric: true });
  });
}
  // --------------------------------------------  Validation for the character -------------------------------------

  toastShown = false;

  checkMaxLength(comment: string) {
    if (comment?.length === 500 && !this.toastShown) {
      this.toastShown = true;

      this.toastr.error('Maximum limit is 500 characters', 'Limit Reached');

      setTimeout(() => {
        this.toastShown = false;
      }, 3000);
    }
  }
  // -------------------------------- Toggle Download Button ---------------------------------------------

  toggleDownloadBtnFn() {
    this.toggleDownloadBtn = !this.toggleDownloadBtn;
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: 'application/octet-stream' });
    const currentDate = new Date();
    const formattedDate = currentDate.toLocaleDateString('en-GB').replace(/\//g, '-');
    saveAs(data, `${fileName}-${formattedDate}.xlsx`);
  }

  // ----------------------- Upload --------------------------------
  onFileSelect(event: any, item: any) {
    const files: string[] = [];
    for (let i = 0; i < event.target.files.length; i++) {
      files.push(event.target.files[i].name);
    }
    item.attachments = [...item.attachments, ...files];

    // If Non R&D, call update immediately
    if (item.categoryName !== 'R&D') {
      this.saveUpdateDWM(item);
    }
  }

  removeSavedAttachments(item: any): void {
    item.attachments = [];
    item.dwmDoc = null;
    item.hasSavedAttachments = false;

    this.saveUpdateDWM(item);
  }

  uploadedFiles: any[] = []; // after upload
  showViewIcon = false;

  onFileSelectt(event: any, item: any): void {
    const files = event.target.files;

    if (files && files.length > 0) {
      item.attachments = item.attachments || [];

      Array.from(files).forEach((file: any) => {
        item.attachments.push(file.name); // or file object if you use later
      });
    }
  }

  openMisPreview(item: any) {
    // console.log('on update download - - - -  ', item);
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = window.innerWidth <= 576 ? '100%' : '80%';
    dialogConfig.panelClass = 'custom-dialog-container';
    dialogConfig.data = {
      attachments: item.attachments
    };

    // console.log(dialogConfig);

    this.dialog.open(DwmattachmentpopupComponent, dialogConfig);
  }

  // ------------------------------- Update DWM ------------------------------
  updateDWM(item: any) {}

  // --------------------------- Cancel Edit ----------------------------------

  // ------------------------------------------------Pagination ---------------------------------------------

  onSelectSizeCount() {
    this.currentPageNumber = 1;
    this.getDwmUpdateData();
  }
  // ------------------------------------------------ previous Page Task ---------------------------------------------

  previousPageTask() {
    if (this.currentPageNumber > 1) {
      this.currentPageNumber--;
      this.getDwmUpdateData();
    }
  }

  nextPageTask() {
    if (this.currentPageNumber < this.totalTaskPages) {
      this.currentPageNumber++;
      this.getDwmUpdateData();
    }
  }

  // ------------------------------- Submit for approval ----------------------------
  submitForApproval(): void {}

  get hasNewRow(): boolean {
    return this.dwmUpdateData?.some(row => row.isNew);
  }

  // --------------------------------------------------------- For R&D Employees ------------------------------------------------------------------------------------

  addNewRow(): void {
    const newRow = {
      isNew: true,
      isEdit: true,
      categoryName: this.isRNDEmployee ? 'R&D' : '',
      productId: null,
      productNumber: null,
      plantLocation: '',
      dwmDuration: null,
      dwmDate: '',
      actionable: '',
      empComments: '',
      attachments: [],
      timeFrom: null,
      timeTo: null,
      dwmFrequency: null,
      dwmStatus: 'Not_Started',
      managerComment: null
    };
    this.dwmUpdateData = [newRow, ...this.dwmUpdateData];
  }

  uploadDWMAttachments(event: any, item: any): void {
    const files: FileList = event.target.files;

    if (!files || files.length === 0) return;

    // -------- File size validation (10MB) --------
    for (let i = 0; i < files.length; i++) {
      const sizeInMB = files[i].size / (1024 * 1024);
      if (sizeInMB > 10) {
        this.toastr.error('File size should not exceed 10MB');
        return;
      }
    }

    const formData = new FormData();

    for (let i = 0; i < files.length; i++) {
      formData.append('files', files[i]);
      formData.append('fileType', files[i].type.split('/')[0]);
    }

    this.loader.simpleLoader();

    const url = this.config.uploadFileLocallymultipleForPMS;

    this.httpService.submitFormService(url, formData).subscribe({
      next: (res: any) => {
        this.loader.dismissLoader();

        /**
         * EXPECTED RESPONSE:
         * res.data = ['path1', 'path2']
         */
        const uploadedPaths = res?.data || [];

        // merge with existing attachments
        item.attachments = [...(item.attachments || []), ...uploadedPaths];

        item.hasSavedAttachments = item.attachments.length > 0;
        // console.log('Uplaodedd..........', item.hasSavedAttachments);
        //  Non R&D → auto save
        if (item.categoryName !== 'R&D') {
          this.saveUpdateDWM(item);
        }
      },
      error: () => {
        this.loader.dismissLoader();
        this.toastr.error('Attachment upload failed');
      }
    });
  }

  isPastDateOnly(dwmDate: string | Date): boolean {
    if (!dwmDate) return false;

    const taskDate = new Date(dwmDate);
    const today = new Date();

    // remove time part
    taskDate.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);

    // allow only past dates
    return taskDate < today;
  }

  saveTask(): void {
    // const tasksToSave = this.dwmUpdateData.filter(t => t.isNew === true);
    const tasksToSave = this.dwmUpdateData.filter(t => t.categoryName === 'R&D');

    if (!tasksToSave.length) {
      this.toastr.warning('No new task to save');
      return;
    }

    //  Mandatory Validation for R&D
    for (let i = 0; i < tasksToSave.length; i++) {
      const task = tasksToSave[i];
      const rowNumber = i + 1;

      if (!task.dwmEventDate) {
        this.toastr.error(` Event Date is mandatory`);
        return;
      }

      if (!task.productNumber) {
        this.toastr.error(` Product is mandatory`);
        return;
      }

      if (!task.plantLocation) {
        this.toastr.error(` Plant is mandatory`);
        return;
      }

      if (!task.dwmDuration) {
        this.toastr.error(` Duration is mandatory`);
        return;
      }

      // Duration format validation (HH:mm max 24:00)
      const durationPattern = /^([01]?\d|2[0-4]):[0-5]\d$/;

      if (!durationPattern.test(task.dwmDuration)) {
        this.toastr.error(` Duration must be in HH:MM format (Max 24:00)`);
        return;
      }
    }

    const payload = tasksToSave.map(task => {
      const normalizeDuration = (val: string | null): string | null => {
        if (!val) return null;

        // If only hours (e.g. "22")
        if (/^\d{1,2}$/.test(val)) {
          return val.padStart(2, '0') + ':00';
        }

        // If HH:m → HH:0m
        if (/^\d{1,2}:\d{1}$/.test(val)) {
          const [h, m] = val.split(':');
          return h.padStart(2, '0') + ':' + m.padStart(2, '0');
        }

        // Already valid HH:mm
        return val;
      };

      const selectedProduct = this.productList.find((p: any) => p.productNumber === task.productNumber);

      return {
        id: task.id ?? null,
        companyId: this.loggedInUserCompanyID,
        userId: Number(this.loggedInUserId),
        managerId: task.managerId ?? null,

        categoryId: this.rAndDCategoryId, // R&D
        plantLocation: task.plantLocation,

        productId: selectedProduct?.productId ?? null,

        actionable: task.actionable ?? null,

        dwmEventDate: task.dwmEventDate ? this.formatDate(task.dwmEventDate) : null,

        dwmDuration: normalizeDuration(task.dwmDuration),

        empComments: task.empComments ?? null,

        dwmStatus: task.dwmStatus,

        dwmDoc: task.attachments?.join(',') || null,

        isCriticalTask: false
      };
    });

    this.httpService.callPostService(this.config.saveRNDEmployee, payload).subscribe({
      next: (res: any) => {
        this.toastr.success('Saved Successfully');

        this.getDwmUpdateData();
      },
      error: (err: any) => {
        const errorMsg = err?.error?.message || 'Save failed';
        this.toastr.warning(errorMsg, 'Warning');
      }
    });
  }

  // --------------------------------- Edit Row ---------------------------------------------

  editRowForRND(index: number) {
    this.taskList.forEach((task: any, i: number) => {
      if (i !== index) task.isEdit = false;
    });
    this.taskList[index].backup = JSON.parse(JSON.stringify(this.taskList[index]));
    this.taskList[index].isEdit = true;
  }

  // --------------------------------- Delete Row ---------------------------------------------
  deleteRow(index: number): void {
    this.dwmUpdateData.splice(index, 1);
    this.dwmUpdateData = [...this.dwmUpdateData];
    this.selectedTaskList = [];
    this.selectAllTaskCheckbox = false;
  }

  // --------------------------------- Save Row ---------------------------------------------

  saveRow(item: any, index: number) {
    item.isEdit = false;
    delete item.backup;
  }

  // --------------------------------- Cancel Edit ---------------------------------------------

  cancelEditForRND(item: any, index: number) {
    if (item.backup) {
      this.taskList[index] = {
        ...item.backup,
        isEdit: false
      };
    }

    delete this.taskList[index].backup;
  }

  // --------------------------------- Delete Row ---------------------------------------------

  // deleteRow(index: number): void {
  //   this.taskList.splice(index, 1);
  //   this.taskList = [...this.taskList];
  //   this.selectedTaskList = [];
  //   this.selectAllTaskCheckbox = false;
  // }

  getProductsData() {
    this.httpService.callGetService(`${this.config.getProducts}?companyId=${this.loggedInUserCompanyID}`).subscribe((res: any) => {
      // console.log('Products Data :', res);
      this.productList = (res?.data || []).map((p: any) => ({
        ...p,
        productNumber: p.productNo
      }));
    });
  }

  dwmSetupData: any[] = [];
  cutOffDate: number | null = null;
  getDWMSetup() {
    this.httpService.callGetService(`${this.config.getDwmSetup}?companyId=${this.loggedInUserCompanyID}`).subscribe((res: any) => {
      const setup = (res?.data || []).find((x: any) => x.fiscalYear === this.selectedYearForDWM);
      if (setup && setup.cutOffDate) {
        this.cutOffDate = Number(setup.cutOffDate);
      }
    });
  }

  // Helper to check if a DWM entry is editable
  isDwmEditable(dwmDate: string | Date): boolean {
    if (!dwmDate || !this.cutOffDate) return true;

    const entryDate = new Date(dwmDate);
    const entryTotalMonths = entryDate.getFullYear() * 12 + entryDate.getMonth();

    const currentMonth = this.today.getMonth();
    const currentYear = this.today.getFullYear();
    const currentDay = this.today.getDate();
    const currentTotalMonths = currentYear * 12 + currentMonth;

    // Current (and future) month entries are always editable
    if (entryTotalMonths >= currentTotalMonths) return true;

    // Immediately previous month is editable only within the cutoff grace period
    if (entryTotalMonths === currentTotalMonths - 1) {
      return currentDay <= this.cutOffDate;
    }

    // Anything older than last month is always locked once a cutoff is configured
    return false;
  }

  showCutoffMessage(): void {
    this.toastr.warning('You can’t update this entry because the cutoff date is over.');
  }

  // Check if current selected date is allowed as per cutoff
  isDwmPageEditable(): boolean {
    if (!this.dwmPlusFormDate || !this.cutOffDate) return true;

    const selectedDate = new Date(this.dwmPlusFormDate);
    const selectedTotalMonths = selectedDate.getFullYear() * 12 + selectedDate.getMonth();

    const currentMonth = this.today.getMonth();
    const currentYear = this.today.getFullYear();
    const currentDay = this.today.getDate();
    const currentTotalMonths = currentYear * 12 + currentMonth;

    // Current (and future) month is always editable
    if (selectedTotalMonths >= currentTotalMonths) return true;

    // Immediately previous month is editable only within the cutoff grace period
    if (selectedTotalMonths === currentTotalMonths - 1) {
      return currentDay <= this.cutOffDate;
    }

    // Anything older than last month is always locked once a cutoff is configured
    return false;
  }

  onClickDeleteRecord() {}

  selectALLTaskRecords(event: any) {}

  selectSingleTaskRecords(event: any, data: any, i: number) {}

  // ----------------------------------------------- Add New Task ---------------------------------------------

  addNewTask() {
    const newRow = {
      id: null,
      checkboxCheck: false,
      category: null,
      actionable: '',
      productNumber: '',
      dwmDuration: '',
      plantLocation: '',
      dwmFrequency: null,
      dwmDate: null,
      empComment: '',
      status: null,
      docAttachments: [],
      isNew: true
    };

    this.taskList.unshift(newRow);
    this.selectedTaskList = [];
    this.selectAllTaskCheckbox = false;
  }

  exportToExcel() {}

  //  ------------------------------------------------ Format Date ---------------------------------------------

  formatDate(date: any): string {
    if (!date) return '';
    const d = new Date(date);
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${d.getFullYear()}-${month}-${day}`;
  }

  //  -------------------------------------------------Format Time  ---------------------------------------------

  formatTime(value: string): string {
    if (!value) return '';
    if (/^\d{2}:\d{2}$/.test(value)) return value;
    if (/^\d{2}:\d{2}:\d{2}$/.test(value)) return value;
    const parts = value.split(':');
    return `${parts[0]}:${parts[1]}`;
  }

  onDocFileSelect(event: any, item: any) {
    if (!item.docAttachments) {
      item.docAttachments = [];
    }

    const files: FileList = event.target.files;
    for (let i = 0; i < files.length; i++) {
      item.docAttachments.push(files[i].name);
    }

    // reset input so same file can be selected again
    event.target.value = '';
  }

  removeDocFile(item: any, index: number) {
    item.docAttachments.splice(index, 1);
  }

  // ----------------------- Compliance & achievement score ---------------
  getComplianceAndAchievment(): void {
    const payload: any = {
      userId: this.loggedInUserId,
      companyId: this.loggedInUserCompanyID
    };

    this.httpService.callPostService(this.config.addCategory, payload).subscribe(
      (data: any) => {},
      (error: any) => {
        this.toastr.error(error.error.message, 'Error');
      }
    );
  }

  //  ----------------------------------- Download PDF & Excel ---------------------------------------
  downloadPDFAndExcel(downloadType: 'pdf' | 'excel') {
    const source = this.dwmUpdateData || [];

    if (!source.length) {
      this.toastr.warning('No task data available to export!');
      return;
    }

    /* ======================= EXCEL ======================= */
    if (downloadType === 'excel') {
      const excelData = source.map((task: any) => {
        return {
          Category: task?.categoryName || '',
          Actionable: task?.actionable || '',
          'Product No': task?.productNumber || '',
          Plant: task?.plantLocation || '',
          Duration: task?.dwmDuration || '',
          Date: task?.dwmEventDate ? this.datePipe.transform(task.dwmEventDate, 'longDate') : '',
          'Time From': task?.timeFrom || '',
          'Time To': task?.timeTo || '',
          Frequency: task?.dwmFrequency || '',
          Status: task?.dwmStatus ? this.dwmGenericServiceService.getStatusLabel(task.dwmStatus) : '',
          'Employee Comment': task?.empComment || '',
          'Manager Comment': task?.managerComments || ''
        };
      });

      this.dwmGenericServiceService.saveAsExcelFile(excelData, 'DWM Update List', 'dwm_update_list');
    }

    /* ======================== PDF ======================== */
    if (downloadType === 'pdf') {
      const pdfHeaders: string[] = ['Category', 'Actionable', 'Product No', 'Plant', 'Duration', 'Date', 'Time From', 'Time To', 'Frequency', 'Status', 'Employee Comment', 'Manager Comment'];

      const pdfData = source.map((task: any) => {
        return [task?.categoryName || '', task?.actionable || '', task?.productNumber || '', task?.plantLocation || '', task?.dwmDuration || '', task?.dwmEventDate ? this.datePipe.transform(task.dwmEventDate, 'longDate') : '', task?.timeFrom || '', task?.timeTo || '', task?.dwmFrequency || '', task?.dwmStatus ? this.dwmGenericServiceService.getStatusLabel(task.dwmStatus) : '', task?.empComment || '', task?.managerComments || ''];
      });

      this.dwmGenericServiceService.downloadTableAsPdf(pdfHeaders, pdfData, 'DWM Update List', 'dwm_update_list');
    }
  }
}
